<script>
  import fetchO from '../../oauth.js'
  import { useNavigate } from 'svelte-navigator'

  import WorkoutPlanMetaEditForm from '../../components/WorkoutPlanMetaEditForm.svelte'

  const navigate = useNavigate()

  let errors

  let saving = false
  async function saveWorkoutPlan(event) {
    console.log('Should create', event.detail)
    saving = true
    const response = await fetchO('/workout_plans/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event.detail),
    })

    const j = await response.json()

    if (response.status != 201) {
      errors = JSON.stringify(j)
    } else {
      navigate('../edit/' + j['id'])
    }
    saving = false
  }
</script>

{#if errors}
  <div class="alert alert-danger" role="alert">
    {errors}
  </div>
{/if}

<h3>Add new Plan</h3>
<WorkoutPlanMetaEditForm
  submitLabel="Create Plan"
  on:save={saveWorkoutPlan}
  {saving}
/>

<svelte:head>
  <title>Add New Fich Workout Plan</title>
</svelte:head>
